import { inject, Injectable, signal } from "@angular/core";

import { Observable } from "rxjs";

import { ApiCacheService } from "@shared/services";
import { RequestConfig, RequestState } from "@shared/models";
import { environment } from "@environments/environment";
import { HssUpdateResponse } from "@shared/models/updates/hss-update-response";

@Injectable({
  providedIn: "root",
})
export class UpdatesService {
  apiCacheService = inject(ApiCacheService);

  timestamp = signal<string>("");

  private readonly _baseUrl = `${environment.seqHistApimUrl}/History`;

  private _updatesRequestConfig: RequestConfig = {
    cacheId: "",
    cacheValidMinutes: 5,
    url: "",
    forceRefresh: false,
  };

  getHistory(
    sequence: string,
    date: string,
    seat: string,
    force?: boolean,
  ): Observable<RequestState<HssUpdateResponse>> {
    this._updatesRequestConfig.url = `${this._baseUrl}/${sequence}/${date}/${seat}`;
    this._updatesRequestConfig.cacheId = `seq-his-updates-v2/${sequence}/${date}/${seat}`;
    if (force) {
      this._updatesRequestConfig.forceRefresh = true;
    } else {
      this._updatesRequestConfig.forceRefresh = false;
    }

    return this.apiCacheService.request<HssUpdateResponse>(
      this._updatesRequestConfig,
    );
  }
}
